import { render, staticRenderFns } from "./annualProductionCapacity.vue?vue&type=template&id=11805f94&scoped=true&"
import script from "./annualProductionCapacity.vue?vue&type=script&lang=js&"
export * from "./annualProductionCapacity.vue?vue&type=script&lang=js&"
import style0 from "./annualProductionCapacity.vue?vue&type=style&index=0&id=11805f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11805f94",
  null
  
)

export default component.exports